var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.dataToShow ? _c('div', [_c('div', {
    staticClass: "my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15"
  }, [_vm.isNewHobbie ? _c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Ajouter un centre d'intérêt")]) : _vm._e(), _vm._v(" "), !_vm.isNewHobbie ? _c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Modifier le centre d'intérêt")]) : _vm._e(), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_vm._v("Saissisez le nom du centre d'intérêt" + _vm._s(_vm.isNewHobbie ? " à ajouter" : "") + ".")]), _vm._v(" "), _vm.isNewHobbie ? _c('h6', {
    staticClass: "text-indigo-600 mb-8"
  }, [_vm._v("Vous pouvez en ajouter plusieurs à la fois en les séparant d’une virgule.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_c('input-text', {
    staticClass: "lg:w-1/2",
    attrs: {
      "error": true,
      "placeholder": "Exemple : “Guitare“",
      "value": _vm.hobbieName,
      "libelle": "Centre d'intérêt",
      "name": "hobbieName"
    },
    on: {
      "input": function (newValue) {
        _vm.hobbieName = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": _vm.isNewHobbie ? 'AJOUTER' : 'MODIFIER',
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.addHobbie();
      }
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }